import { Component, Vue, Watch } from 'vue-property-decorator';
import PortalVue from 'portal-vue'

//################ BEGIN Tivigi imports #################
import FullscreenButton from 'tivigi/src/components/FullscreenButton/FullscreenButton'
import Modal from 'tivigi/src/components/Modal/Modal'
import SmartButton from 'tivigi/src/components/SmartButton/SmartButton'
import Tooltip from 'tivigi/src/components/Tooltip/Tooltip'
import { getUrlState, setUrlState } from 'tivigi/src/util/urlStateKeeping';
//################ END Tivigi imports #################

import CmsMenu from '../CmsMenu/CmsMenu'
import Toolbar from 'tivigi/src/components/Toolbar/Toolbar'
import * as dataStore from '../../dataStore'
import WithRender from './App.html';
import './App.scss'

Vue.use(PortalVue)

@WithRender
@Component({
    components: {
        CmsMenu,
        FullscreenButton,
        Modal, 
        SmartButton,
        Toolbar,
        Tooltip
    }
})
export default class App extends Vue {

    isDev = false    
    mobile = true

    


    get global() {
        return dataStore.store
    }


    get showSidebar() : boolean {
        return this.global.showNavbar        
    }

    set showSidebar(newval : boolean) {
        
        this.global.showNavbar = newval

        const state = getUrlState()

        state.showSidebar = this.showSidebar
        
     //   setUrlState(state)
    }


    beforeDestroy() {
        window.removeEventListener("resize", this.onWindowResize)
 
    }


    getDynamicClass(): any {

        return {
            "App__Sidebar"  :true,
            "Flex--col": true,
            "hide-on-print" : true,
            "App__Sidebar--overlay" : this.mobile
        }
    }


    // NOTE: Here, we use created() instead of mounted() so that the state of "mobile" is determined
    // before the sidebar is created.
    created() {

        window.addEventListener("resize", this.onWindowResize)

        this.onWindowResize() 
                
        const state = getUrlState()

        if (state.showSidebar != undefined) {
            this.showSidebar = state.showSidebar
        }

     
    }


    onWindowResize() {
        this.mobile = document.documentElement.offsetWidth < 1000
    }


    onMenuClick() {
        if (this.mobile) {
            this.showSidebar = false
        }
    }
}
